module.exports = __webpack_public_path__ + "img/newecologo.33ab44d2.png";